import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { rem } from '../../../core';

const modifiers = {
  required: ({ theme }) => ({
    styles: `
      font-size: ${rem(13)};
      font-weight: 800;
      color: ${theme.greyDark4};
      margin-bottom: ${rem(8)};

      &::before {
        content: "* ";
        color: ${theme.status.danger};
      }
    `,
  }),

  default: ({ theme }) => ({
    styles: `
      font-size: ${rem(13)};
      font-weight: 800;
      color: ${theme.greyDark4};
      margin-bottom: ${rem(8)};
    `,
  }),
};

export const LabelStyled = styled.label.attrs({
  className: 'component__label',
})`
  font-size: ${rem(15)};
  color: #333333;
  margin-bottom: ${rem(15)};
  display: block;
  ${applyStyleModifiers(modifiers)};
`;
